import { Pause, Play } from 'lucide-react'

import { formatTime } from '@/lib/cue-parser'

import { SkipIcon } from './skip-icon'

type Props = {
  title: string
  playing: boolean
  currentTime: number
  duration: number
  onPlayPause: () => void
  onSkip: (delta: number) => void
}

/**
 * PDFタブ表示中の画面下部に表示されるミニプレーヤー
 * オーディオ再生の状態表示と基本操作を提供する
 */
export const MiniPlayer = ({ title, playing, currentTime, duration, onPlayPause, onSkip }: Props) => {
  const progress = duration > 0 ? (currentTime / duration) * 100 : 0

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border shadow-lg">
      {/* プログレスバー */}
      <div className="h-0.5 bg-muted">
        <div className="h-full bg-primary transition-[width] duration-300" style={{ width: `${progress}%` }} />
      </div>

      <div className="flex items-center gap-3 px-4 py-2">
        {/* タイトル・時間 */}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium truncate">{title}</p>
          <p className="text-xs text-muted-foreground">
            {formatTime(currentTime)} / {formatTime(duration)}
          </p>
        </div>

        {/* コントロール */}
        <div className="flex items-center gap-2">
          <button type="button" onClick={() => onSkip(-30)} className="p-1.5" aria-label="30秒戻る">
            <SkipIcon direction="backward" seconds={30} size={24} className="text-muted-foreground" />
          </button>

          <button
            type="button"
            onClick={onPlayPause}
            className="p-2 rounded-full bg-primary text-primary-foreground"
            aria-label={playing ? '一時停止' : '再生'}
          >
            {playing ? <Pause size={18} fill="currentColor" /> : <Play size={18} fill="currentColor" />}
          </button>

          <button type="button" onClick={() => onSkip(30)} className="p-1.5" aria-label="30秒進む">
            <SkipIcon direction="forward" seconds={30} size={24} className="text-muted-foreground" />
          </button>
        </div>
      </div>
    </div>
  )
}
